import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var SplitPipe = (function () {
    function SplitPipe() {
    }
    SplitPipe.prototype.transform = function (input, separator, limit) {
        if (separator === void 0) { separator = ' '; }
        if (!isString(input)) {
            return input;
        }
        return input.split(separator, limit);
    };
    return SplitPipe;
}());
export { SplitPipe };
SplitPipe.decorators = [
    { type: Pipe, args: [{
                name: 'split'
            },] },
];
/** @nocollapse */
SplitPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=split.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/split.pipe.js
// module id = 289
// module chunks = 103